import { Fragment, FunctionComponent, useState, useContext } from 'react';
import * as T from './Quiz.types';
import * as s from './Quiz.css';
import FinishedQuiz from './FinishedQuiz/FinishedQuiz';
import Step from 'Components/Quiz/Step';
import QuizHeader from 'Components/QuizHeader';
import QuizContext from 'Context/QuizContext';
import { counterTrigger } from 'Tools/counters';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import { IQuizQuestionAPI } from 'Src/typings/api';
const Quiz: FunctionComponent<T.IQuizProps> = ({ petName, quizType, questions, onFinishQuiz, renderFinal, showFirstPage, }) => {
    // Обработка и хранение ответов
    const [answerList, collectAnswerList] = useState(new Map());
    // Устанавливает активный вопрос
    const [activeQuestion, setActiveQuestion] = useState(0);
    // Проверяет, завершен ли опрос
    const isFinished = activeQuestion + 1 > questions.length;
    const { pet, setPetBranch } = useContext(QuizContext);
    /**
     * Выбор следюущего вопроса
     * @param event
     */
    const chooseNextQuestion = (event: any) => {
        const currentAnswerId = Number(event.currentTarget.dataset.id);
        const nextQuestion = activeQuestion + 1;
        const petType = pet ? pet[0].toUpperCase() + pet.substr(1) : null;
        const { question, answers } = questions[activeQuestion];
        const currentAnswer = answers.find((answer) => answer.id === currentAnswerId);
        const answerText = currentAnswer ? currentAnswer?.text : '';
        const snitchEventName = quizType === 'social'
            ? 'petQuizAnswerQuestion'
            : 'marketQuizAnswerQuestion';
        snitchCounter(snitchEventName, {
            questionNumber: nextQuestion,
            totalQuestions: questions.length,
            questionText: question,
            answerText,
        });
        // Сохранение ответа на текущий вопрос
        collectAnswerList(new Map(answerList.set(activeQuestion, currentAnswerId)));
        petType && counterTrigger(`quiz${petType}Q${nextQuestion}`);
        if (nextQuestion === questions.length) {
            const answerIds = Array.from(answerList.values());
            onFinishQuiz(answerIds);
        }
        // Переход к следующему вопросу
        setActiveQuestion(nextQuestion);
    };
    /**
     * Выбор предыдущего вопроса
     */
    const choosePreviousQuestion = () => {
        const prevQuestion = activeQuestion - 1;
        // Если вопросов нет, вернуться на экран выбора питомца
        if (prevQuestion < 0) {
            setPetBranch(null);
        }
        setActiveQuestion(prevQuestion);
    };
    const restartTest = () => {
        const eventName = quizType === 'social' ? 'petQuizRepeat' : 'marketQuizRepeat';
        if (showFirstPage) {
            showFirstPage();
        }
        counterTrigger('marketQuizRetest');
        snitchCounter(eventName);
        setPetBranch(null);
    };
    /**
     * Рисует все шаги теста
     */
    const renderSteps = () => {
        if (!questions) {
            return null;
        }
        // Собираем все шаги, рисуем только активный
        const questionSteps = questions.map((question: IQuizQuestionAPI, index: number) => {
            const isVisible = activeQuestion === index;
            return (isVisible && (<Step {...question} key={`question-id-${question.id}`} petName={petName} currentStep={index + 1} totalSteps={questions.length} onChooseAnswer={chooseNextQuestion} onClickBack={choosePreviousQuestion} reverseContent={pet === 'cat'}/>));
        });
        return <div className={s.quiz}>{questionSteps}</div>;
    };
    /**
     * Рисует шаг с результатами
     */
    const renderCompilations = () => {
        return renderFinal ? (renderFinal({ pet, restartTest })) : (<FinishedQuiz type={pet as 'dog' | 'cat'} onRestart={restartTest}/>);
    };
    return (<Fragment>
      <QuizHeader quizType={quizType} progressBarStart={activeQuestion} progressBarEnd={questions.length}/>
      {!isFinished ? renderSteps() : renderCompilations()}
    </Fragment>);
};
export default Quiz;
